import React from "react";
import ReactDOM from "react-dom/client";
import Answers from "./Answers";
// If you moved index.css back to src, keep this line.
// If you don't use index.css, you can remove it.
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Answers />
  </React.StrictMode>,
);
